import { Divider, List } from "antd"
import { useSelector } from "react-redux"
import { Customer } from "src/common/models/customer"
import { RootState } from "src/state/reducer"
import { AvatarContainer } from "./styles";
import { getServiceInitials } from "src/common/util";
import { FormActionButtons } from "src/components/FormActionButtons";
import { useEffect, useState } from "react";
import { SystemDescriptions } from "src/common/descriptions";
import Search from "antd/es/transfer/search";

interface Props {
    onAccept: (customer: Customer) => void
    onCancel: VoidFunction
}

export type ReduxProps = {
    customers: Customer[]
}

export const ClientSelector = (props: Props) => {

    const [selectedCustomer, setSelectedCustomer] = useState<Customer | undefined>(undefined)
    const [searchValue, setSearchValue] = useState<string | undefined>()
    const [filteredCustomers, setFilteredCustomers] = useState<Customer[]>([])

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        customers: state.customer.customers || [],
    }))

    const descriptions = SystemDescriptions.PAGES.SERVICE_CONTRACT

    useEffect(() => {
        if (searchValue) {
            const filtered = reduxProps.customers.filter(customer => customer.name.toLowerCase().includes(searchValue.toLowerCase()))
            setFilteredCustomers(filtered)
        } else {
            setFilteredCustomers(reduxProps.customers)
        }
    }, [searchValue])

    const renderNameAvatar = (name: string) => (
        <AvatarContainer>
            {getServiceInitials(name)}
        </AvatarContainer>
    )

    const getButtonStatus = (): boolean => {
        return selectedCustomer === undefined
    }

    const handleCancelClick = () => {
        props.onCancel()
    }

    const handleAcceptClick = () => {
        if (selectedCustomer) {
            props.onAccept(selectedCustomer)
        }
    }

    const renderButtons = () => (
        <FormActionButtons
            cancelText={descriptions.CREATE_SERVICE_CONTRACT.CANCEL_BUTTON}
            actionText={descriptions.CREATE_SERVICE_CONTRACT.SAVE_BUTTON}
            actionDisabled={getButtonStatus}
            onCancel={handleCancelClick}
            onAccept={handleAcceptClick}
        />
    )

    const handleSearchChange = (e: any) => {
        setSearchValue(e.target.value)
    }

    return (
        <>
            <div style={{ height: 310, overflowY: 'scroll' }} >
                <div style={{ marginBottom: 10 }}>
                    <Search
                        placeholder="Search"
                        onChange={handleSearchChange}
                    />
                </div>
                <List
                    dataSource={filteredCustomers.sort((a, b) => a.name.localeCompare(b.name))}
                    renderItem={(item: Customer) => (
                        <List.Item key={item.name}
                            style={{
                                backgroundColor: selectedCustomer?.id === item.id ? '#f5f5f5' : 'white',
                                cursor: 'pointer',
                            }}
                            onClick={() => {
                                setSelectedCustomer(item)
                            }}
                        >
                            <List.Item.Meta
                                avatar={renderNameAvatar(item.name)}
                                title={item.name}
                                description={item.manager}
                            />
                        </List.Item>
                    )}
                />
            </div >
            <Divider />
            {renderButtons()}
        </>
    )
}
